import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./initialState";
import { mySpaceReducer } from "./reducer";
import { MySpaceType } from "./mySpaceTypes";
import {
  addCheckInScheduleAction,
  addCheckInScheduleFeedbackApiAction,
  addPerformanceEvaluationAction,
  addPerformanceEvaluationFeedbackAction,
  getAttendanceAverageAction,
  getAverageJobRatingListAction,
  getCheckInScheduleListAction,
  getCheckInScheduleManagerViewListAction,
  getManagersAvailableCheckInScheduleSlotsDetailsAction,
  getMySpaceUpcomingBirthDayAction,
  getMySpaceWorkAnniversaryAction,
  getMyTeamMembersAction,
  getPeopleOnLeaveAction,
  getPerformanceEvaluationListAction,
  getSingleCheckInScheduleDetailsAction,
  getSinglePerformanceEvaluationDetailsAction,
  updateCheckInScheduleAction,
} from "./actions";

export const mySpaceSlice = createSlice({
  name: "mySpace",
  initialState,
  reducers: mySpaceReducer,
  extraReducers: {
    [getMySpaceWorkAnniversaryAction.pending.toString()]: (
      state: MySpaceType
    ) => ({
      ...state,
      workAnniversaryfetching: true,
    }),
    [getMySpaceWorkAnniversaryAction.fulfilled.toString()]: (
      state: MySpaceType,
      { payload }
    ) => {
      const { success, message, result, status_code, count } = payload;
      if (success === 0) {
        return {
          ...state,
          workAnniversaryfetching: false,
          success: 0,
          error: message,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        workAnniversaryfetching: false,
        mySpaceWorkAnniversaryList: result?.events,
        upcomingEventsTotalCount: result.total_count,
      };
    },
    [getMySpaceWorkAnniversaryAction.rejected.toString()]: (
      state: MySpaceType,
      { error }
    ) => ({
      ...state,
      workAnniversaryfetching: false,
      success: 0,
      error: error.message,
    }),
    //
    [getMySpaceUpcomingBirthDayAction.pending.toString()]: (
      state: MySpaceType
    ) => ({
      ...state,
      upcomingBirthDayFetching: true,
    }),
    [getMySpaceUpcomingBirthDayAction.fulfilled.toString()]: (
      state: MySpaceType,
      { payload }
    ) => {
      const { success, message, result, status_code, count } = payload;
      if (success === 0) {
        return {
          ...state,
          upcomingBirthDayFetching: false,
          success: 0,
          error: message,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        upcomingBirthDayFetching: false,
        upcomingBirthdayList: result?.events,
        upcomingBirthdayTotalCount: result.total_count,
      };
    },
    [getMySpaceUpcomingBirthDayAction.rejected.toString()]: (
      state: MySpaceType,
      { error }
    ) => ({
      ...state,
      upcomingBirthDayFetching: false,
      success: 0,
      error: error.message,
    }),
    //people on leave
    [getPeopleOnLeaveAction.pending.toString()]: (state: MySpaceType) => ({
      ...state,
      peopleOnLeaveFetching: true,
    }),
    [getPeopleOnLeaveAction.fulfilled.toString()]: (
      state: MySpaceType,
      { payload }
    ) => {
      const { success, message, result, status_code, count } = payload;
      if (success === 0) {
        return {
          ...state,
          peopleOnLeaveFetching: false,
          success: 0,
          error: message,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        peopleOnLeaveFetching: false,
        peopleOnLeaveData: result?.employees,
      };
    },
    [getPeopleOnLeaveAction.rejected.toString()]: (
      state: MySpaceType,
      { error }
    ) => ({
      ...state,
      peopleOnLeaveFetching: false,
      success: 0,
      error: error.message,
    }),

    [getAttendanceAverageAction.pending.toString()]: (state: MySpaceType) => ({
      ...state,
      attendanceAverageFetching: true,
    }),
    [getAttendanceAverageAction.fulfilled.toString()]: (
      state: MySpaceType,
      { payload }
    ) => {
      const { success, message, result, status_code } = payload;
      if (success === 0) {
        return {
          ...state,
          attendanceAverageFetching: false,
          success: 0,
          error: message,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        attendanceAverageFetching: false,
        attendanceAverage: result?.overall_average,
      };
    },
    [getAttendanceAverageAction.rejected.toString()]: (
      state: MySpaceType,
      { error }
    ) => ({
      ...state,
      attendanceAverageFetching: false,
      success: 0,
      error: error.message,
    }),
    [addCheckInScheduleAction.pending.toString()]: (state: MySpaceType) => ({
      ...state,
      checkInScheduleFetching: true,
    }),
    [addCheckInScheduleAction.fulfilled.toString()]: (
      state: MySpaceType,
      { payload }
    ) => {
      const { success, message, result, status_code } = payload;
      if (success === 0) {
        return {
          ...state,
          checkInScheduleFetching: false,
          success: 0,
          error: message,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        checkInScheduleFetching: false,
        message,
        success,
      };
    },
    [addCheckInScheduleAction.rejected.toString()]: (
      state: MySpaceType,
      { error }
    ) => ({
      ...state,
      checkInScheduleFetching: false,
      success: 0,
      error: error.message,
    }),
    [addCheckInScheduleFeedbackApiAction.pending.toString()]: (
      state: MySpaceType
    ) => ({
      ...state,
      checkInScheduleFetching: true,
    }),
    [addCheckInScheduleFeedbackApiAction.fulfilled.toString()]: (
      state: MySpaceType,
      { payload }
    ) => {
      const { success, message, status_code } = payload;
      if (success === 0) {
        return {
          ...state,
          checkInScheduleFetching: false,
          success: 0,
          error: message,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        checkInScheduleFetching: false,
        message,
        success,
      };
    },
    [addCheckInScheduleFeedbackApiAction.rejected.toString()]: (
      state: MySpaceType,
      { error }
    ) => ({
      ...state,
      checkInScheduleFetching: false,
      success: 0,
      error: error.message,
    }),
    [updateCheckInScheduleAction.pending.toString()]: (state: MySpaceType) => ({
      ...state,
      checkInScheduleFetching: true,
    }),
    [updateCheckInScheduleAction.fulfilled.toString()]: (
      state: MySpaceType,
      { payload }
    ) => {
      const { success, message, result, status_code } = payload;
      if (success === 0) {
        return {
          ...state,
          checkInScheduleFetching: false,
          success: 0,
          error: message,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        checkInScheduleFetching: false,
        success,
        message,
      };
    },
    [updateCheckInScheduleAction.rejected.toString()]: (
      state: MySpaceType,
      { error }
    ) => ({
      ...state,
      checkInScheduleFetching: false,
      success: 0,
      error: error.message,
    }),
    [getCheckInScheduleListAction.pending.toString()]: (
      state: MySpaceType
    ) => ({
      ...state,
      checkInScheduleFetching: true,
    }),
    [getCheckInScheduleListAction.fulfilled.toString()]: (
      state: MySpaceType,
      { payload }
    ) => {
      const { success, message, result, status_code, total_count } = payload;
      if (success === 0) {
        return {
          ...state,
          checkInScheduleFetching: false,
          success: 0,
          error: message,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        checkInScheduleFetching: false,
        checkInScheduleList: result,
        checkInScheduleTotalCount: total_count,
      };
    },
    [getCheckInScheduleListAction.rejected.toString()]: (
      state: MySpaceType,
      { error }
    ) => ({
      ...state,
      checkInScheduleFetching: false,
      success: 0,
      error: error.message,
    }),
    [getCheckInScheduleManagerViewListAction.pending.toString()]: (
      state: MySpaceType
    ) => ({
      ...state,
      checkInScheduleFetching: true,
    }),
    [getCheckInScheduleManagerViewListAction.fulfilled.toString()]: (
      state: MySpaceType,
      { payload }
    ) => {
      const { success, message, result, status_code, total_count } = payload;
      if (success === 0) {
        return {
          ...state,
          checkInScheduleFetching: false,
          success: 0,
          error: message,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        checkInScheduleFetching: false,
        checkInScheduleManagerViewList: result,
        checkInScheduleManagerViewTotalCount: total_count,
      };
    },
    [getCheckInScheduleManagerViewListAction.rejected.toString()]: (
      state: MySpaceType,
      { error }
    ) => ({
      ...state,
      checkInScheduleFetching: false,
      success: 0,
      error: error.message,
    }),

    [getSingleCheckInScheduleDetailsAction.pending.toString()]: (
      state: MySpaceType
    ) => ({
      ...state,
      singleCheckInScheduleFetching: true,
    }),
    [getSingleCheckInScheduleDetailsAction.fulfilled.toString()]: (
      state: MySpaceType,
      { payload }
    ) => {
      const { success, message, result, status_code } = payload;
      if (success === 0) {
        return {
          ...state,
          singleCheckInScheduleFetching: false,
          success: 0,
          error: message,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        singleCheckInScheduleFetching: false,
        singleCheckInScheduleDetails: result,
      };
    },
    [getSingleCheckInScheduleDetailsAction.rejected.toString()]: (
      state: MySpaceType,
      { error }
    ) => ({
      ...state,
      singleCheckInScheduleFetching: false,
      success: 0,
      error: error.message,
    }),

    [getManagersAvailableCheckInScheduleSlotsDetailsAction.pending.toString()]:
      (state: MySpaceType) => ({
        ...state,
        checkInScheduleFetching: true,
      }),
    [getManagersAvailableCheckInScheduleSlotsDetailsAction.fulfilled.toString()]:
      (state: MySpaceType, { payload }) => {
        const { success, message, result, status_code } = payload;
        if (success === 0) {
          return {
            ...state,
            checkInScheduleFetching: false,
            success: 0,
            error: message,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          checkInScheduleFetching: false,
          managersAvailableCheckInScheduleSlots: result,
        };
      },
    [getManagersAvailableCheckInScheduleSlotsDetailsAction.rejected.toString()]:
      (state: MySpaceType, { error }) => ({
        ...state,
        checkInScheduleFetching: false,
        success: 0,
        error: error.message,
      }),

      [getPerformanceEvaluationListAction.pending.toString()]: (
        state: MySpaceType
      ) => ({
        ...state,
        performanceEvaluationFetching: true,
      }),
      [getPerformanceEvaluationListAction.fulfilled.toString()]: (
        state: MySpaceType,
        { payload }
      ) => {
        const { success, message, result, status_code, total_count } = payload;
        if (success === 0) {
          return {
            ...state,
            performanceEvaluationFetching: false,
            success: 0,
            error: message,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          performanceEvaluationFetching: false,
          performanceEvaluationList: result,
          performanceEvaluationTotalCount: total_count,
        };
      },
      [getPerformanceEvaluationListAction.rejected.toString()]: (
        state: MySpaceType,
        { error }
      ) => ({
        ...state,
        performanceEvaluationFetching: false,
        success: 0,
        error: error.message,
      }),

      [addPerformanceEvaluationAction.pending.toString()]: (state: MySpaceType) => ({
        ...state,
        performanceEvaluationFetching: true,
      }),
      [addPerformanceEvaluationAction.fulfilled.toString()]: (
        state: MySpaceType,
        { payload }
      ) => {
        const { success, message, result, status_code } = payload;
        if (success === 0) {
          return {
            ...state,
            performanceEvaluationFetching: false,
            success: 0,
            error: message,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          performanceEvaluationFetching: false,
          message,
          success,
        };
      },
      [addPerformanceEvaluationAction.rejected.toString()]: (
        state: MySpaceType,
        { error }
      ) => ({
        ...state,
        performanceEvaluationFetching: false,
        success: 0,
        error: error.message,
      }),

      [getSinglePerformanceEvaluationDetailsAction.pending.toString()]: (
        state: MySpaceType
      ) => ({
        ...state,
        singlePeFetching: true,
      }),
      [getSinglePerformanceEvaluationDetailsAction.fulfilled.toString()]: (
        state: MySpaceType,
        { payload }
      ) => {
        const { success, message, result, status_code } = payload;
        if (success === 0) {
          return {
            ...state,
            singlePeFetching: false,
            success: 0,
            error: message,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          singlePeFetching: false,
          singlePeDetailsList: result,
        };
      },
      [getSinglePerformanceEvaluationDetailsAction.rejected.toString()]: (
        state: MySpaceType,
        { error }
      ) => ({
        ...state,
        singlePeFetching: false,
        success: 0,
        error: error.message,
      }),
      [addPerformanceEvaluationFeedbackAction.pending.toString()]: (
        state: MySpaceType
      ) => ({
        ...state,
        performanceEvaluationFetching: true,
      }),
      [addPerformanceEvaluationFeedbackAction.fulfilled.toString()]: (
        state: MySpaceType,
        { payload }
      ) => {
        const { success, message, status_code } = payload;
        if (success === 0) {
          return {
            ...state,
            performanceEvaluationFetching: false,
            success: 0,
            error: message,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          performanceEvaluationFetching: false,
          message,
          success,
        };
      },
      [addPerformanceEvaluationFeedbackAction.rejected.toString()]: (
        state: MySpaceType,
        { error }
      ) => ({
        ...state,
        performanceEvaluationFetching: false,
        success: 0,
        error: error.message,
      }),
    
      [getAverageJobRatingListAction.pending.toString()]: (
        state: MySpaceType
      ) => ({
        ...state,
        averageJobRatingFetching: true,
      }),
      [getAverageJobRatingListAction.fulfilled.toString()]: (
        state: MySpaceType,
        { payload }
      ) => {
        const { success, message, result, status_code, total_count,average } = payload;
        if (success === 0) {
          return {
            ...state,
            averageJobRatingFetching: false,
            success: 0,
            error: message,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          averageJobRatingFetching: false,
          averageJobRatingList: result,
          averageJobRatingCount: total_count,
          averageJobRatingData:average
        };
      },
      [getAverageJobRatingListAction.rejected.toString()]: (
        state: MySpaceType,
        { error }
      ) => ({
        ...state,
        averageJobRatingFetching: false,
        success: 0,
        error: error.message,
      }),

      // view my team members
      [getMyTeamMembersAction.pending.toString()]: (state: MySpaceType) => ({
        ...state,
        viewTeamMembersFetching: true,
      }),
      [getMyTeamMembersAction.fulfilled.toString()]: (
        state: MySpaceType,
        { payload }
      ) => {
        const { success, status_code, message, total_count, result} = payload;
        if(success === 0) {
          return {
            ...state,
            viewTeamMembersFetching: false,
            success: 0,
            error: message,
            statusCode: status_code,
            
          }
        }
        return{
          ...state,
          viewTeamMembersFetching: false,
          viewTeamMembersData: result,
          viewTeamMembersCount: total_count,
        };
      },
      [getMyTeamMembersAction.rejected.toString()]: (
        state: MySpaceType,
        { error }
      ) => ({
        ...state,
        viewTeamMembersFetching: false,
        success: 0,
        error: error.message,
      }),
  },
});

export const {
  resetMySpaceSuccess,
  resetMySpaceError,
  resetMySpaceMessage,
  resetMySpaceStatusCode,
  resetMySpaceWorkAnniversaryList,
  resetUpcomingBirthdayList,
  resetPeopleOnLeaveList,
  resetAttendanceAverage,
  resetCheckInScheduleList,
  resetSingleCheckInScheduleDetails,
  resetCheckInScheduleManagerViewList,
  resetManagersAvailableCheckInScheduleSlots,
  resetPerformanceEvaluationList,
  resetPerformanceEvaluationTotalCount,
  resetSinglePeDetailsList,
  resetAverageJobRatingList,
  resetViewMyTeamMembersData,
  resetViewMyTeamMembersCount
} = mySpaceSlice.actions;
